// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-hC4","buttons":"styles_buttons__2KY_w"};